
 function formatrole(role){
    switch(role ) {
        case 'global admin': 
            return 'global_admin'
        break;
        case 'super admin':
            return 'super_admin'
        break;
        case 'market admin' : 
            return 'market_admin'
        break;
        case 'entity_admin':
            return 'entity_admin'
    }
}

export default formatrole;